import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { CancelOrderRequestBody } from "./cancelOrder.types";

export const requestCancelOrder = async (
  body: CancelOrderRequestBody
): Promise<void> => {
  return await instance.put(ApiRoutesOrders.CancelOrder, body);
};
